<template>
  <div>

  </div>
</template>

<script>
import { setToken, getToken } from "@/utils/token";
import { login } from "@/api/user";

export default {
  name: "login",

  data() {
    return {
      //请求json
      loginData: {
        username: "",
        sign: "",
        timestamp: "",
      },
    }
  },

  created() {
    //判断是否错误信息
    if (this.$route.query.errormsg) {
      this.$toast.fail(this.$route.query.errormsg);
      return;
    }
    //获取传入的信息
    let username = this.$route.query.username; //用户名或者邮箱
    let timestamp = this.$route.query.timestamp; //时间戳 到秒
    let sign = this.$route.query.sign; //sign=MD5(username+MD5(password)+timestamp)
    //参数不能为空
    if (username == null || username == '') {
      this.$toast.fail('用户名不能为空');
      return;
    }
    if (timestamp == null || timestamp == '') {
      this.$toast.fail('时间戳不能为空');
      return;
    }
    if (sign == null || sign == '') {
      this.$toast.fail('签名不能为空');
      return;
    }
    //构造请求
    this.loginData.username = username;
    this.loginData.timestamp = timestamp;
    this.loginData.sign = sign;
    //登录
    login(this.loginData).then((res) => {
      setToken(res);
      this.$router.push({ name: "index" });
    });
  },

  mounted() {

  },

  methods: {

  },

};
</script>

<style lang="less"></style>


// WEBPACK FOOTER //
// src/view/user/login.vue